module.exports = __webpack_public_path__ + "img/freestyle-info.5bd2228c.png";